<template>
  <div class="component-input-key_people-people">
    <FormWizardStepHeader
      title="Key people"
      optional
      description="Show who’s behind the investments"
    />

    <div class="component-input-key_people__list">
      <div v-if="form.keyPeople.length" class="mb-60">
        <SlickList
          v-if="form.keyPeople.length > 1"
          :key="`slicklist-${form.keyPeople.length}`"
          v-model="form.keyPeople"
        >
          <SlickItem
            v-for="(item, index) in form.keyPeople"
            :key="`index-${index}${item.name.first}${item.name.last}`"
            :index="index"
            class="component-input-key_people__list__item"
          >
            <InvestorKeyPeopleListItem
              :item="item"
              @edit="onEdit"
              @remove="remove"
            />
          </SlickItem>
        </SlickList>

        <div
          v-if="form.keyPeople.length === 1"
          key="single"
          class="component-input-key_people__list__item"
        >
          <InvestorKeyPeopleListItem
            :item="form.keyPeople[0]"
            @edit="onEdit"
            @remove="remove"
          />
        </div>
      </div>
    </div>

    <AlertSlideUpDown :show="$v.keyPeople.$error"
      >Please add at least one person from your startup</AlertSlideUpDown
    >

    <InvestorAddKeyPeopleForm
      :use-user-as-placeholder="
        !$v.keyPeople.$dirty && form.keyPeople.length === 0
      "
      :editing="editing"
      :founders="false"
      @add="add"
      @cancel="editing = null"
    />
  </div>
</template>

<script>
import { SlickItem, SlickList } from 'vue-slicksort'
import InvestorAddKeyPeopleForm from '@/components/create-startups/CompanyAddTeamForm'
import InvestorKeyPeopleListItem from '@/components/create-startups/CompanyTeamListItem'
import FormWizardStepHeader from '@/components/FormWizardStepHeader'
import AlertSlideUpDown from '@/components/AlertSlideUpDown'

export default {
  name: 'InvestorFormStepKeyPeople',
  components: {
    AlertSlideUpDown,
    FormWizardStepHeader,
    InvestorKeyPeopleListItem,
    InvestorAddKeyPeopleForm,
    SlickItem,
    SlickList
  },
  props: {
    $v: {
      type: Object,
      required: true
    },
    value: {
      type: Object
    },
    forms: {
      type: Object
    }
  },
  data() {
    return {
      editing: null,
      form: {
        ...this.value
      }
    }
  },
  watch: {
    value(newValue) {
      this.form = newValue
    },
    form: {
      deep: true,
      handler() {
        this.$emit('input', this.form)
      }
    }
  },
  methods: {
    onEdit(item) {
      this.editing = item
    },
    add(member) {
      if (this.editing) {
        Object.assign(this.editing, member)
        this.editing = null
      } else {
        this.form.keyPeople.push(member)
      }
    },
    remove(member) {
      if (this.editing === member) {
        this.editing = null
      }

      const index = this.form.keyPeople.indexOf(member)
      this.form.keyPeople.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.component-input-key_people {
  &__list {
    &__item {
      background: #fff;
      border-bottom: 1px solid $border-color;
    }
  }
}
</style>
